async function getVariantMetafields(productId, variantId) {
  // Convert numeric IDs to Shopify GIDs
  const variantGid = `gid://shopify/ProductVariant/${variantId}`;
  
  const query = `{
    node(id: "${variantGid}") {
      ... on ProductVariant {
        id
        title
        metafield(namespace: "custom", key: "orion_test_metafield") {
          value
          type
        }
      }
    }
  }`;
  
  const response = await fetch('https://staging.auratenewyork.com/api/2024-10/graphql.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': '5f4d8601e3566b2257a5ca3bc818f3ca'
    },
    body: JSON.stringify({ query })
  });
  
  const data = await response.json();
  return data.data.node.metafield;
}

console.log('test0r')

const cartData = await fetch('/cart.js').then(r => r.json());

for (const item of cartData.items) {
  const shippingDate = await getVariantMetafields(item.product_id, item.variant_id);
  console.log('Shipping date:', shippingDate?.value);
}
